import React from 'react';

export function FinalizedIllustration() {
  return (
    <svg
      width="100%"
      viewBox="0 0 408 221"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.417969"
        y="0.5"
        width="407.164"
        height="220"
        rx="6.56716"
        fill="white"
      />
      <rect
        x="29.1484"
        y="13.6343"
        width="58.2836"
        height="4.92537"
        rx="2.46269"
        fill="#CED3E1"
      />
      <rect
        x="14.373"
        y="31.6938"
        width="87.8358"
        height="175.672"
        rx="6.56716"
        fill="#F5F6F8"
      />
      <g clip-path="url(#clip0_2095_144021)">
        <rect
          x="20.9395"
          y="44.0073"
          width="73.8806"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-6-inside-1_2095_144021" fill="white">
          <path d="M20.9395 44.0073H94.8201V54.1903H20.9395V44.0073Z" />
        </mask>
        <path
          d="M20.9395 44.0073H94.8201V54.1903H20.9395V44.0073Z"
          fill="#DEE4F4"
        />
        <path
          d="M94.8201 54.1903V53.8817H20.9395V54.1903V54.4989H94.8201V54.1903Z"
          fill="#DCE0E9"
          mask="url(#path-6-inside-1_2095_144021)"
        />
        <rect
          x="25.877"
          y="57.4736"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="21.0937"
        y="44.1616"
        width="73.572"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip1_2095_144021)">
        <rect
          x="20.9395"
          y="72.2617"
          width="73.8806"
          height="34.0185"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-11-inside-2_2095_144021" fill="white">
          <path d="M20.9395 72.2617H94.8201V82.4447H20.9395V72.2617Z" />
        </mask>
        <path
          d="M20.9395 72.2617H94.8201V82.4447H20.9395V72.2617Z"
          fill="#F1D3F3"
        />
        <path
          d="M94.8201 82.4447V82.1361H20.9395V82.4447V82.7533H94.8201V82.4447Z"
          fill="#DCE0E9"
          mask="url(#path-11-inside-2_2095_144021)"
        />
        <rect
          x="25.877"
          y="85.728"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="25.877"
          y="91.48"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="25.877"
          y="95.5908"
          width="62.3881"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="25.877"
          y="99.7012"
          width="27.9104"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="21.0937"
        y="72.416"
        width="73.572"
        height="33.7099"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip2_2095_144021)">
        <rect
          x="20.9395"
          y="112.847"
          width="35.709"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-19-inside-3_2095_144021" fill="white">
          <path d="M20.9395 112.847H56.6484V123.03H20.9395V112.847Z" />
        </mask>
        <path
          d="M20.9395 112.847H56.6484V123.03H20.9395V112.847Z"
          fill="#D8EAEB"
        />
        <path
          d="M56.6484 123.03V122.722H20.9395V123.03V123.339H56.6484V123.03Z"
          fill="#DCE0E9"
          mask="url(#path-19-inside-3_2095_144021)"
        />
        <rect
          x="25.877"
          y="126.313"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="21.0937"
        y="113.001"
        width="35.4004"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip3_2095_144021)">
        <rect
          x="59.9316"
          y="112.847"
          width="35.709"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-24-inside-4_2095_144021" fill="white">
          <path d="M59.9316 112.847H95.6406V123.03H59.9316V112.847Z" />
        </mask>
        <path
          d="M59.9316 112.847H95.6406V123.03H59.9316V112.847Z"
          fill="#CEE9F7"
        />
        <path
          d="M95.6406 123.03V122.722H59.9316V123.03V123.339H95.6406V123.03Z"
          fill="#DCE0E9"
          mask="url(#path-24-inside-4_2095_144021)"
        />
        <rect
          x="64.8691"
          y="126.313"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="60.0859"
        y="113.001"
        width="35.4004"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip4_2095_144021)">
        <rect
          x="20.9395"
          y="141.102"
          width="73.8806"
          height="34.0185"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-29-inside-5_2095_144021" fill="white">
          <path d="M20.9395 141.102H94.8201V151.285H20.9395V141.102Z" />
        </mask>
        <path
          d="M20.9395 141.102H94.8201V151.285H20.9395V141.102Z"
          fill="#FDE3BD"
        />
        <path
          d="M94.8201 151.285V150.976H20.9395V151.285V151.594H94.8201V151.285Z"
          fill="#DCE0E9"
          mask="url(#path-29-inside-5_2095_144021)"
        />
        <rect
          x="25.877"
          y="154.568"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="25.877"
          y="160.32"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="25.877"
          y="164.431"
          width="62.3881"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="25.877"
          y="168.542"
          width="27.9104"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="21.0937"
        y="141.256"
        width="73.572"
        height="33.7099"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <rect
        x="126.699"
        y="13.6343"
        width="58.2836"
        height="4.92537"
        rx="2.46269"
        fill="#CED3E1"
      />
      <rect
        x="112.334"
        y="31.6938"
        width="87.0149"
        height="175.672"
        rx="6.56716"
        fill="#F5F6F8"
      />
      <g clip-path="url(#clip5_2095_144021)">
        <rect
          x="118.9"
          y="44.0073"
          width="73.8806"
          height="29.9081"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-39-inside-6_2095_144021" fill="white">
          <path d="M118.9 44.0073H192.781V54.1903H118.9V44.0073Z" />
        </mask>
        <path
          d="M118.9 44.0073H192.781V54.1903H118.9V44.0073Z"
          fill="#F1D3F3"
        />
        <path
          d="M192.781 54.1903V53.8817H118.9V54.1903V54.4989H192.781V54.1903Z"
          fill="#DCE0E9"
          mask="url(#path-39-inside-6_2095_144021)"
        />
        <rect
          x="123.838"
          y="57.4736"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="123.838"
          y="63.2256"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="123.838"
          y="67.3364"
          width="62.3881"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="119.055"
        y="44.1616"
        width="73.572"
        height="29.5995"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip6_2095_144021)">
        <rect
          x="118.9"
          y="80.4824"
          width="73.8806"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-46-inside-7_2095_144021" fill="white">
          <path d="M118.9 80.4824H192.781V90.6654H118.9V80.4824Z" />
        </mask>
        <path
          d="M118.9 80.4824H192.781V90.6654H118.9V80.4824Z"
          fill="#E9D9D3"
        />
        <path
          d="M192.781 90.6654V90.3568H118.9V90.6654V90.974H192.781V90.6654Z"
          fill="#DCE0E9"
          mask="url(#path-46-inside-7_2095_144021)"
        />
        <rect
          x="123.838"
          y="93.9487"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="119.055"
        y="80.6367"
        width="73.572"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip7_2095_144021)">
        <rect
          x="118.9"
          y="108.737"
          width="73.8806"
          height="29.9081"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-51-inside-8_2095_144021" fill="white">
          <path d="M118.9 108.737H192.781V118.92H118.9V108.737Z" />
        </mask>
        <path d="M118.9 108.737H192.781V118.92H118.9V108.737Z" fill="#FFBDBD" />
        <path
          d="M192.781 118.92V118.611H118.9V118.92V119.228H192.781V118.92Z"
          fill="#DCE0E9"
          mask="url(#path-51-inside-8_2095_144021)"
        />
        <rect
          x="123.838"
          y="122.203"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="123.838"
          y="127.955"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="123.838"
          y="132.066"
          width="27.9104"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="119.055"
        y="108.891"
        width="73.572"
        height="29.5995"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip8_2095_144021)">
        <rect
          x="118.9"
          y="145.212"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-58-inside-9_2095_144021" fill="white">
          <path d="M118.9 145.212H154.199V155.395H118.9V145.212Z" />
        </mask>
        <path
          d="M118.9 145.212H154.199V155.395H118.9V145.212Z"
          fill="#EDF7CA"
        />
        <path
          d="M154.199 155.395V155.087H118.9V155.395V155.704H154.199V155.395Z"
          fill="#DCE0E9"
          mask="url(#path-58-inside-9_2095_144021)"
        />
        <rect
          x="123.838"
          y="158.679"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="119.055"
        y="145.367"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip9_2095_144021)">
        <rect
          x="157.482"
          y="145.212"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-63-inside-10_2095_144021" fill="white">
          <path d="M157.482 145.212H192.781V155.395H157.482V145.212Z" />
        </mask>
        <path
          d="M157.482 145.212H192.781V155.395H157.482V145.212Z"
          fill="#CEE9F7"
        />
        <path
          d="M192.781 155.395V155.087H157.482V155.395V155.704H192.781V155.395Z"
          fill="#DCE0E9"
          mask="url(#path-63-inside-10_2095_144021)"
        />
        <rect
          x="162.42"
          y="158.679"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="157.637"
        y="145.367"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip10_2095_144021)">
        <rect
          x="118.9"
          y="173.467"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-68-inside-11_2095_144021" fill="white">
          <path d="M118.9 173.467H154.199V183.65H118.9V173.467Z" />
        </mask>
        <path d="M118.9 173.467H154.199V183.65H118.9V173.467Z" fill="#CEE9F7" />
        <path
          d="M154.199 183.65V183.341H118.9V183.65V183.958H154.199V183.65Z"
          fill="#DCE0E9"
          mask="url(#path-68-inside-11_2095_144021)"
        />
        <rect
          x="123.838"
          y="186.933"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="119.055"
        y="173.621"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip11_2095_144021)">
        <rect
          x="157.482"
          y="173.467"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-73-inside-12_2095_144021" fill="white">
          <path d="M157.482 173.467H192.781V183.65H157.482V173.467Z" />
        </mask>
        <path
          d="M157.482 173.467H192.781V183.65H157.482V173.467Z"
          fill="#EDF7CA"
        />
        <path
          d="M192.781 183.65V183.341H157.482V183.65V183.958H192.781V183.65Z"
          fill="#DCE0E9"
          mask="url(#path-73-inside-12_2095_144021)"
        />
        <rect
          x="162.42"
          y="186.933"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="157.637"
        y="173.621"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <rect
        x="223.838"
        y="13.6343"
        width="58.2836"
        height="4.92537"
        rx="2.46269"
        fill="#CED3E1"
      />
      <rect
        x="209.473"
        y="31.6938"
        width="87.0149"
        height="175.672"
        rx="6.56716"
        fill="#F5F6F8"
      />
      <g clip-path="url(#clip12_2095_144021)">
        <rect
          x="216.039"
          y="44.0073"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-80-inside-13_2095_144021" fill="white">
          <path d="M216.039 44.0073H251.338V54.1903H216.039V44.0073Z" />
        </mask>
        <path
          d="M216.039 44.0073H251.338V54.1903H216.039V44.0073Z"
          fill="#D8EAEB"
        />
        <path
          d="M251.338 54.1903V53.8817H216.039V54.1903V54.4989H251.338V54.1903Z"
          fill="#DCE0E9"
          mask="url(#path-80-inside-13_2095_144021)"
        />
        <rect
          x="220.977"
          y="57.4736"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="216.193"
        y="44.1616"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip13_2095_144021)">
        <rect
          x="254.621"
          y="44.0073"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-85-inside-14_2095_144021" fill="white">
          <path d="M254.621 44.0073H289.92V54.1903H254.621V44.0073Z" />
        </mask>
        <path
          d="M254.621 44.0073H289.92V54.1903H254.621V44.0073Z"
          fill="#CEE9F7"
        />
        <path
          d="M289.92 54.1903V53.8817H254.621V54.1903V54.4989H289.92V54.1903Z"
          fill="#DCE0E9"
          mask="url(#path-85-inside-14_2095_144021)"
        />
        <rect
          x="259.559"
          y="57.4736"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="254.775"
        y="44.1616"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip14_2095_144021)">
        <rect
          x="216.039"
          y="72.2617"
          width="73.8806"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-90-inside-15_2095_144021" fill="white">
          <path d="M216.039 72.2617H289.92V82.4447H216.039V72.2617Z" />
        </mask>
        <path
          d="M216.039 72.2617H289.92V82.4447H216.039V72.2617Z"
          fill="#DEE4F4"
        />
        <path
          d="M289.92 82.4447V82.1361H216.039V82.4447V82.7533H289.92V82.4447Z"
          fill="#DCE0E9"
          mask="url(#path-90-inside-15_2095_144021)"
        />
        <rect
          x="220.977"
          y="85.728"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="216.193"
        y="72.416"
        width="73.572"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip15_2095_144021)">
        <rect
          x="216.039"
          y="100.516"
          width="73.8806"
          height="34.0185"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-95-inside-16_2095_144021" fill="white">
          <path d="M216.039 100.516H289.92V110.699H216.039V100.516Z" />
        </mask>
        <path
          d="M216.039 100.516H289.92V110.699H216.039V100.516Z"
          fill="#FFF0B3"
        />
        <path
          d="M289.92 110.699V110.39H216.039V110.699V111.008H289.92V110.699Z"
          fill="#DCE0E9"
          mask="url(#path-95-inside-16_2095_144021)"
        />
        <rect
          x="220.977"
          y="113.982"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="220.977"
          y="119.734"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="220.977"
          y="123.845"
          width="62.3881"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="220.977"
          y="127.956"
          width="27.9104"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="216.193"
        y="100.67"
        width="73.572"
        height="33.7099"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip16_2095_144021)">
        <rect
          x="216.039"
          y="141.102"
          width="73.8806"
          height="34.0185"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-103-inside-17_2095_144021" fill="white">
          <path d="M216.039 141.102H289.92V151.285H216.039V141.102Z" />
        </mask>
        <path
          d="M216.039 141.102H289.92V151.285H216.039V141.102Z"
          fill="#FDE3BD"
        />
        <path
          d="M289.92 151.285V150.976H216.039V151.285V151.594H289.92V151.285Z"
          fill="#DCE0E9"
          mask="url(#path-103-inside-17_2095_144021)"
        />
        <rect
          x="220.977"
          y="154.568"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="220.977"
          y="160.32"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="220.977"
          y="164.431"
          width="62.3881"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="220.977"
          y="168.542"
          width="27.9104"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="216.193"
        y="141.256"
        width="73.572"
        height="33.7099"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <rect
        x="320.977"
        y="13.6343"
        width="58.2836"
        height="4.92537"
        rx="2.46269"
        fill="#CED3E1"
      />
      <rect
        x="306.611"
        y="31.6938"
        width="87.0149"
        height="175.672"
        rx="6.56716"
        fill="#F5F6F8"
      />
      <g clip-path="url(#clip17_2095_144021)">
        <rect
          x="313.178"
          y="44.0073"
          width="73.8806"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-113-inside-18_2095_144021" fill="white">
          <path d="M313.178 44.0073H387.058V54.1903H313.178V44.0073Z" />
        </mask>
        <path
          d="M313.178 44.0073H387.058V54.1903H313.178V44.0073Z"
          fill="#DEE4F4"
        />
        <path
          d="M387.058 54.1903V53.8817H313.178V54.1903V54.4989H387.058V54.1903Z"
          fill="#DCE0E9"
          mask="url(#path-113-inside-18_2095_144021)"
        />
        <rect
          x="318.115"
          y="57.4736"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="313.332"
        y="44.1616"
        width="73.572"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip18_2095_144021)">
        <rect
          x="313.178"
          y="72.2617"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-118-inside-19_2095_144021" fill="white">
          <path d="M313.178 72.2617H348.476V82.4447H313.178V72.2617Z" />
        </mask>
        <path
          d="M313.178 72.2617H348.476V82.4447H313.178V72.2617Z"
          fill="#D8EAEB"
        />
        <path
          d="M348.476 82.4447V82.1361H313.178V82.4447V82.7533H348.476V82.4447Z"
          fill="#DCE0E9"
          mask="url(#path-118-inside-19_2095_144021)"
        />
        <rect
          x="318.115"
          y="85.728"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="313.332"
        y="72.416"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip19_2095_144021)">
        <rect
          x="351.76"
          y="72.2617"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-123-inside-20_2095_144021" fill="white">
          <path d="M351.76 72.2617H387.058V82.4447H351.76V72.2617Z" />
        </mask>
        <path
          d="M351.76 72.2617H387.058V82.4447H351.76V72.2617Z"
          fill="#F1D3F3"
        />
        <path
          d="M387.058 82.4447V82.1361H351.76V82.4447V82.7533H387.058V82.4447Z"
          fill="#DCE0E9"
          mask="url(#path-123-inside-20_2095_144021)"
        />
        <rect
          x="356.697"
          y="85.728"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="351.914"
        y="72.416"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip20_2095_144021)">
        <rect
          x="313.178"
          y="100.516"
          width="73.8806"
          height="34.0185"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-128-inside-21_2095_144021" fill="white">
          <path d="M313.178 100.516H387.058V110.699H313.178V100.516Z" />
        </mask>
        <path
          d="M313.178 100.516H387.058V110.699H313.178V100.516Z"
          fill="#FFBDBD"
        />
        <path
          d="M387.058 110.699V110.39H313.178V110.699V111.008H387.058V110.699Z"
          fill="#DCE0E9"
          mask="url(#path-128-inside-21_2095_144021)"
        />
        <rect
          x="318.115"
          y="113.982"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="318.115"
          y="119.734"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="318.115"
          y="123.845"
          width="62.3881"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="318.115"
          y="127.956"
          width="27.9104"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="313.332"
        y="100.67"
        width="73.572"
        height="33.7099"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip21_2095_144021)">
        <rect
          x="313.178"
          y="141.102"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-136-inside-22_2095_144021" fill="white">
          <path d="M313.178 141.102H348.476V151.285H313.178V141.102Z" />
        </mask>
        <path
          d="M313.178 141.102H348.476V151.285H313.178V141.102Z"
          fill="#D8EAEB"
        />
        <path
          d="M348.476 151.285V150.976H313.178V151.285V151.594H348.476V151.285Z"
          fill="#DCE0E9"
          mask="url(#path-136-inside-22_2095_144021)"
        />
        <rect
          x="318.115"
          y="154.568"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="313.332"
        y="141.256"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip22_2095_144021)">
        <rect
          x="351.76"
          y="141.102"
          width="35.2985"
          height="21.6873"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-141-inside-23_2095_144021" fill="white">
          <path d="M351.76 141.102H387.058V151.285H351.76V141.102Z" />
        </mask>
        <path
          d="M351.76 141.102H387.058V151.285H351.76V141.102Z"
          fill="#CEE9F7"
        />
        <path
          d="M387.058 151.285V150.976H351.76V151.285V151.594H387.058V151.285Z"
          fill="#DCE0E9"
          mask="url(#path-141-inside-23_2095_144021)"
        />
        <rect
          x="356.697"
          y="154.568"
          width="16.4179"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
      </g>
      <rect
        x="351.914"
        y="141.256"
        width="34.9899"
        height="21.3787"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <g clip-path="url(#clip23_2095_144021)">
        <rect
          x="313.178"
          y="169.356"
          width="73.8806"
          height="34.0185"
          rx="2.4686"
          fill="white"
        />
        <mask id="path-146-inside-24_2095_144021" fill="white">
          <path d="M313.178 169.356H387.058V179.539H313.178V169.356Z" />
        </mask>
        <path
          d="M313.178 169.356H387.058V179.539H313.178V169.356Z"
          fill="#D8CCFD"
        />
        <path
          d="M387.058 179.539V179.231H313.178V179.539V179.848H387.058V179.539Z"
          fill="#DCE0E9"
          mask="url(#path-146-inside-24_2095_144021)"
        />
        <rect
          x="318.115"
          y="182.823"
          width="33.6567"
          height="3.28358"
          rx="1.64179"
          fill="#CED3E1"
        />
        <rect
          x="318.115"
          y="188.575"
          width="55.8209"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="318.115"
          y="192.686"
          width="62.3881"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
        <rect
          x="318.115"
          y="196.796"
          width="27.9104"
          height="1.64179"
          rx="0.820895"
          fill="#ECEDF1"
        />
      </g>
      <rect
        x="313.332"
        y="169.511"
        width="73.572"
        height="33.7099"
        rx="2.31431"
        stroke="#DCE0E9"
        strokeWidth="0.308575"
      />
      <defs>
        <clipPath id="clip0_2095_144021">
          <rect
            x="20.9395"
            y="44.0073"
            width="73.8806"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_2095_144021">
          <rect
            x="20.9395"
            y="72.2617"
            width="73.8806"
            height="34.0185"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip2_2095_144021">
          <rect
            x="20.9395"
            y="112.847"
            width="35.709"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_2095_144021">
          <rect
            x="59.9316"
            y="112.847"
            width="35.709"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip4_2095_144021">
          <rect
            x="20.9395"
            y="141.102"
            width="73.8806"
            height="34.0185"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip5_2095_144021">
          <rect
            x="118.9"
            y="44.0073"
            width="73.8806"
            height="29.9081"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip6_2095_144021">
          <rect
            x="118.9"
            y="80.4824"
            width="73.8806"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip7_2095_144021">
          <rect
            x="118.9"
            y="108.737"
            width="73.8806"
            height="29.9081"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip8_2095_144021">
          <rect
            x="118.9"
            y="145.212"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip9_2095_144021">
          <rect
            x="157.482"
            y="145.212"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip10_2095_144021">
          <rect
            x="118.9"
            y="173.467"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip11_2095_144021">
          <rect
            x="157.482"
            y="173.467"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip12_2095_144021">
          <rect
            x="216.039"
            y="44.0073"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip13_2095_144021">
          <rect
            x="254.621"
            y="44.0073"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip14_2095_144021">
          <rect
            x="216.039"
            y="72.2617"
            width="73.8806"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip15_2095_144021">
          <rect
            x="216.039"
            y="100.516"
            width="73.8806"
            height="34.0185"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip16_2095_144021">
          <rect
            x="216.039"
            y="141.102"
            width="73.8806"
            height="34.0185"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip17_2095_144021">
          <rect
            x="313.178"
            y="44.0073"
            width="73.8806"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip18_2095_144021">
          <rect
            x="313.178"
            y="72.2617"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip19_2095_144021">
          <rect
            x="351.76"
            y="72.2617"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip20_2095_144021">
          <rect
            x="313.178"
            y="100.516"
            width="73.8806"
            height="34.0185"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip21_2095_144021">
          <rect
            x="313.178"
            y="141.102"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip22_2095_144021">
          <rect
            x="351.76"
            y="141.102"
            width="35.2985"
            height="21.6873"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip23_2095_144021">
          <rect
            x="313.178"
            y="169.356"
            width="73.8806"
            height="34.0185"
            rx="2.4686"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
